exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/components/tracker-pair/tracker-pair.component.scss
// module id = ../../../../../src/app/components/tracker-pair/tracker-pair.component.scss
// module chunks = main